var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23740",
    "data-name": "Rectangle 23740",
    width: 55,
    height: 55,
    transform: "translate(886 1213)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67435",
    "data-name": "Group 67435",
    transform: "translate(-886 -1213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11",
    "data-name": "Mask Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59463",
    "data-name": "Group 59463",
    transform: "translate(611.617 1231.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77407",
    "data-name": "Path 77407",
    d: "M276.745,5.012h50.276l-25.138-15.22Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1721",
    "data-name": "Line 1721",
    x2: 36.43,
    transform: "translate(284.245 25.142)",
    fill: "none",
    stroke: "#8faa44",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23736",
    "data-name": "Rectangle 23736",
    width: 11.292,
    height: 15.22,
    transform: "translate(296.384 9.922)",
    fill: "none",
    stroke: "#8faa44",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1722",
    "data-name": "Line 1722",
    x2: 15,
    transform: "translate(294.245 32.444)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1719",
    "data-name": "Line 1719",
    y2: 25.923,
    transform: "translate(284.11 9.136)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1720",
    "data-name": "Line 1720",
    y2: 25.923,
    transform: "translate(320.049 9.136)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardone);
export default __webpack_public_path__ + "static/media/cardone.09e3030c61742a6485b759dd01791d66.svg";
export { ForwardRef as ReactComponent };